import { DownloadIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Button } from '@/components/ui/button';
import { PanelSectionTitle } from '@/modules/tryIt/shared/InfoRow';
import { InsightValues } from '@/shared/types/analytics';
import { downloadJson } from '@/util/fileManager';

import { InsightItem } from './InsightItem';

type Props = { insights?: Record<string, InsightValues> | null; sessionId?: string };

export const InsightsList = ({ insights, sessionId }: Props) => {
  const { t } = useTranslation();

  const entries = Object.entries(insights ?? {});
  if (entries.length === 0) {
    return null;
  }

  const handleDownload = () => downloadJson(insights, `insights_${sessionId ?? 'session'}`);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-1.5">
        <PanelSectionTitle>{t('try_it.review.insights')}</PanelSectionTitle>
        <InfoTooltip content={t('try_it.review.download_insights')} side="bottom">
          <Button
            type="button"
            size="icon-sm"
            variant="ghost-neutral"
            onClick={handleDownload}
            aria-label={t('try_it.review.download_insights')}
          >
            <DownloadIcon size={16} />
          </Button>
        </InfoTooltip>
      </div>
      <div className="-mx-3 flex flex-col">
        {entries.map(([key, value]) => (
          <InsightItem key={key} name={key} raw={value} />
        ))}
      </div>
    </div>
  );
};
